import { ButtonText } from '@components/index';
import { cloneStyled } from '@utils/cloneStyled';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  overflow-x: auto;
  column-gap: 8px;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Photo = styled.img`
  height: 64px;
  width: 80px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #d8dae5;
  cursor: pointer;
`;

export const NoPhotos = styled.div`
  color: #696f8c;
  font-size: 14px;
  font-weight: 400;
`;
export const RowButton = cloneStyled(
  ButtonText,
  styled(ButtonText)`
    && {
      padding-top: 10px;
      padding-bottom: 10px;
    }

    display: block;
    [data-disabled],
    [data-disabled] * {
      cursor: not-allowed;
    }
  `,
);
export const AddPhoto = styled.a`
  color: #1371fe;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;
